import * as types from './types'
import { SharedTab } from './reducer';

export const init = () => ({
  type: types.INIT
})

export const updateSharedTabs = (newTabs) => ({
  type: types.UPDATE_SHARED_TABS,
  newTabs,
})

export const addNewSharedTab = (newTab: SharedTab, selectedCustomerId = '') => ({
  type: types.ADD_NEW_SHARED_TAB,
  newTab,
  selectedCustomerId,
})

export const deleteSharedTab = (id, showMessage = true) => ({ type: types.DELETE_SHARED_TAB, id, showMessage })
